import HeroB2B from "@/components/HeroB2B";
import EnterpriseTrust from "@/components/EnterpriseTrust";
import B2BChallenges from "@/components/B2BChallenges";
import B2BSolutions from "@/components/B2BSolutions";
import B2BMethodology from "@/components/B2BMethodology";
import B2BTestimonials from "@/components/B2BTestimonials";
import TrustpilotWidget from "@/components/TrustpilotWidget";
import B2BCTA from "@/components/B2BCTA";
import EnhancedSEO from "@/components/SEO/EnhancedSEO";

const HomeV2 = () => {
  return (
    <>
      <EnhancedSEO 
        type="homepage"
        title="VGP | B2B Growth Infrastructure - Demand Generation & Pipeline Acceleration"
        description="Enterprise-grade B2B marketing that builds predictable pipeline. Account-based marketing, LinkedIn SDR, and demand generation for companies serious about revenue growth."
        keywords="B2B marketing, demand generation, account-based marketing, LinkedIn SDR, B2B lead generation, enterprise marketing, pipeline acceleration"
        url="/"
      />
      <div className="min-h-screen bg-background">
        <HeroB2B />
        <EnterpriseTrust />
        <B2BChallenges />
        <B2BSolutions />
        <B2BMethodology />
        <B2BTestimonials />
        <TrustpilotWidget />
        <B2BCTA />
      </div>
    </>
  );
};

export default HomeV2;
